import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function LESS
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={32}
            adderFlag={20}
            showLabelInput={true}
            labelBlock={'<'}
            comparatorLetters={true}
            userConfiguration={true}
        />
    );
}
export default LESS